webpackJsonp([114276838955818,60335399758886],{

/***/ 94:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(193);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(94);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Logo = __webpack_require__(40);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact(props) {
	    return _react2.default.createElement(
	        'section',
	        { id: 'contact' },
	        _react2.default.createElement(
	            'div',
	            { className: 'inner', style: { maxWidth: '50em' } },
	            _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'contact-method' },
	                        _react2.default.createElement('span', { className: 'icon alt fa-home' }),
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Dove Siamo'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Sede Operativa: Viale dell\'Agricoltura, 21 Carpi (MO)'
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Sede Legale: Via Meloni di Quartirolo, 6 Carpi (MO)'
	                        )
	                    )
	                ),
	                _react2.default.createElement('iframe', { src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d45306.13172204353!2d10.817475573536214!3d44.788282116394605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477f8ccf6205628b%3A0x7f3eabae2cc86add!2sMaglificio+LSM!5e0!3m2!1sit!2sau!4v1516487140565', width: '600', height: '450', frameBorder: '0', style: { border: 0, maxWidth: '100%', width: '100%' }, allowFullScreen: true })
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'split' },
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'contact-method' },
	                        _react2.default.createElement('span', { className: 'icon alt fa-envelope' }),
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Email'
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'mailto:amministrazione@maglificiolsm.com' },
	                            'amministrazione@maglificiolsm.com'
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'mailto:commerciale@maglificiolsm.com' },
	                            'commerciale@maglificiolsm.com'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'contact-method' },
	                        _react2.default.createElement('span', { className: 'icon alt fa-phone' }),
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Telefono e Fax'
	                        ),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Tel: +39 059 641 460'
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            'Fax: +39 059 622 8465'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/', style: { textDecoration: 'none' } },
	                        _react2.default.createElement(_Logo2.default, null)
	                    )
	                )
	            )
	        )
	    );
	};
	// import logo from './../assets/images/logo lsm maglificio.jpg'
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	    return _react2.default.createElement(
	        "footer",
	        { id: "footer" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "ul",
	                { className: "icons" },
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: "#", className: "icon alt fa-twitter" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "label" },
	                            "Twitter"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: "#", className: "icon alt fa-facebook" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "label" },
	                            "Facebook"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: "#", className: "icon alt fa-instagram" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "label" },
	                            "Instagram"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: "#", className: "icon alt fa-github" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "label" },
	                            "GitHub"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: "#", className: "icon alt fa-linkedin" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "label" },
	                            "LinkedIn"
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "ul",
	                { className: "copyright" },
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "\xA9 Untitled"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Design: ",
	                    _react2.default.createElement(
	                        "a",
	                        { href: "https://html5up.net" },
	                        "HTML5 UP"
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(props) {
	    return _react2.default.createElement(
	        'header',
	        { id: 'header', className: 'alt' },
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', className: 'logo' },
	            _react2.default.createElement(
	                'strong',
	                { style: { letterSpacing: 0 } },
	                'LSM'
	            )
	        ),
	        _react2.default.createElement(
	            'nav',
	            null,
	            _react2.default.createElement(
	                'a',
	                { className: 'menu-link', onClick: props.onToggleMenu, href: 'javascript:;' },
	                'Menu'
	            )
	        )
	    );
	};
	
	Header.propTypes = {
	    onToggleMenu: _react2.default.PropTypes.func
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo() {
	           return _react2.default.createElement(
	                      "header",
	                      { style: { marginBottom: "12vh", textAlign: "center" } },
	                      _react2.default.createElement(
	                                 "h1",
	                                 { style: { letterSpacing: "-2px", marginBottom: "0", fontSize: "6rem", lineHeight: "5rem" } },
	                                 "LSM"
	                      ),
	                      _react2.default.createElement(
	                                 "h4",
	                                 { className: "f-serif" },
	                                 "MAGLIFICIO"
	                      )
	           );
	};
	exports.default = Logo;
	module.exports = exports["default"];

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu(props) {
	    return _react2.default.createElement(
	        'nav',
	        { id: 'menu' },
	        _react2.default.createElement(
	            'div',
	            { className: 'inner' },
	            _react2.default.createElement(
	                'ul',
	                { className: 'links' },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/' },
	                        _react2.default.createElement(
	                            'h1',
	                            { style: { letterSpacing: '-2px', fontSize: '3rem', lineHeight: '2rem' } },
	                            'LSM'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/' },
	                        'Home'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/storia' },
	                        'Storia'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/private-label' },
	                        'Private Label'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/contatti' },
	                        'Contatti'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'a',
	            { className: 'close', onClick: props.onToggleMenu, href: 'javascript:;' },
	            'Close'
	        )
	    );
	};
	
	Menu.propTypes = {
	    onToggleMenu: _react2.default.PropTypes.func
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(321);
	
	var _Header = __webpack_require__(190);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Menu = __webpack_require__(191);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Contact = __webpack_require__(72);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _Footer = __webpack_require__(189);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	    _inherits(Template, _React$Component);
	
	    function Template(props) {
	        _classCallCheck(this, Template);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            isMenuVisible: false,
	            loading: 'is-loading'
	        };
	        _this.handleToggleMenu = _this.handleToggleMenu.bind(_this);
	        return _this;
	    }
	
	    Template.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        this.timeoutId = setTimeout(function () {
	            _this2.setState({ loading: '' });
	        }, 100);
	    };
	
	    Template.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.timeoutId) {
	            clearTimeout(this.timeoutId);
	        }
	    };
	
	    Template.prototype.handleToggleMenu = function handleToggleMenu() {
	        this.setState({
	            isMenuVisible: !this.state.isMenuVisible
	        });
	    };
	
	    Template.prototype.render = function render() {
	        var children = this.props.children;
	
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'body ' + this.state.loading + ' ' + (this.state.isMenuVisible ? 'is-menu-visible' : '') },
	            _react2.default.createElement(
	                'div',
	                { id: 'wrapper' },
	                _react2.default.createElement(_Header2.default, { onToggleMenu: this.handleToggleMenu }),
	                children()
	            ),
	            _react2.default.createElement(_Menu2.default, { onToggleMenu: this.handleToggleMenu })
	        );
	    };
	
	    return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	    children: _react2.default.PropTypes.func
	};
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-596c388e2e63d719ea24.js